// extracted by mini-css-extract-plugin
export default {"root":"storage-pool-form_root__aeeD1"};